export default __webpack_public_path__ + "static/media/gallery_05.11fc803e.jpg";